import { MSSMembers, MSSPhone } from '@lib/types';
import { formatDateToMMDDYYYY, toProperCase } from '../utils/formatters';
import { IMemberDetails } from './model';

export const mapMemberDetailsApiResponseToState = (apiResponse: IMemberDetails): IMemberDetails => {
  const { loggedInMember, members, termEffectiveDate, termExpirationDate, priorTermExpirationDate } = apiResponse;
  return {
    ...apiResponse,
    termEffectiveDate: formatDateToMMDDYYYY(termEffectiveDate!),
    termExpirationDate: formatDateToMMDDYYYY(termExpirationDate!),
    priorTermExpirationDate: formatDateToMMDDYYYY(priorTermExpirationDate!),
    loggedInMember: {
      ...(loggedInMember as MSSMembers),
      firstName: toProperCase(loggedInMember?.firstName!) || '',
      lastName: toProperCase(loggedInMember?.lastName!) || '',
      middleName: toProperCase(loggedInMember?.middleName!) || '',
      dateOfBirth: formatDateToMMDDYYYY(loggedInMember?.dateOfBirth!) || null,
      residenceAddress: {
        addressLine1: toProperCase(loggedInMember?.residenceAddress?.addressLine1!) || '',
        addressLine2: toProperCase(loggedInMember?.residenceAddress?.addressLine2!) || undefined,
        city: toProperCase(loggedInMember?.residenceAddress?.city!) || '',
        state: loggedInMember?.residenceAddress?.state || '',
        zip: loggedInMember?.residenceAddress?.zip || '',
      },
      mailingAddress: {
        addressLine1: toProperCase(loggedInMember?.mailingAddress?.addressLine1!) || '',
        addressLine2: toProperCase(loggedInMember?.mailingAddress?.addressLine2!) || undefined,
        city: toProperCase(loggedInMember?.mailingAddress?.city!) || '',
        state: loggedInMember?.mailingAddress?.state || '',
        zip: loggedInMember?.mailingAddress?.zip || '',
      },
      phoneNumbers: zeroOutInvalidPhoneNumbers(loggedInMember?.phoneNumbers || []),
    },
    members: getFormattedMembers(members || []),
  };
};

const getFormattedMembers = (members: MSSMembers[]): MSSMembers[] => {
  return members.map((member) => ({
    ...(member as MSSMembers),
    firstName: toProperCase(member.firstName) || '',
    middleName: toProperCase(member.middleName!) || '',
    lastName: toProperCase(member.lastName) || '',
    dateOfBirth: formatDateToMMDDYYYY(member.dateOfBirth!) || null,
    phoneNumbers: zeroOutInvalidPhoneNumbers(member.phoneNumbers || []),
  }));
};

const zeroOutInvalidPhoneNumbers = (phoneNumbers: MSSPhone[]) => {
  const zeroValuePhoneNumbers = ['0'.repeat(10), '2'.repeat(10), '3'.repeat(10), '5'.repeat(10)];
  return phoneNumbers?.map((mssPhone) => {
    const rawPhoneNumber = (mssPhone.areaCode || '') + (mssPhone.prefix || '') + (mssPhone.suffix || '');
    const isZeroValuePhoneNumber = zeroValuePhoneNumbers.includes(rawPhoneNumber);

    if (isZeroValuePhoneNumber) {
      return {
        ...mssPhone,
        areaCode: '',
        prefix: '',
        suffix: '',
      };
    }

    return mssPhone;
  });
};
